module.exports = __webpack_public_path__ + "static/media/1 05 gjerde.56944330.mp3";